import React, { FC } from 'react';
import { useEnhancedFormContext } from '@shared/modules/form';
import { UpdateProfileParams } from '@modules/auth/model';
import { Paper, SimpleGrid, TextInput } from '@mantine/core';

interface UpdateProfileFormProps {
  email: string;
}

const UpdateProfileForm: FC<UpdateProfileFormProps> = ({ email }) => {
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useEnhancedFormContext<UpdateProfileParams>();

  return (
    <form onSubmit={handleSubmit} noValidate>
      <Paper p="xl" withBorder={false}>
        <TextInput type="email" label="E-mail" required disabled value={email} />

        <SimpleGrid mt="md" cols={2}>
          <TextInput
            id="lastName"
            label="Nom"
            placeholder="Nom"
            required
            error={!!errors.lastName}
            {...register('lastName')}
          />

          <TextInput
            id="firstName"
            label="Prénom"
            placeholder="Prénom"
            error={!!errors.firstName}
            required
            {...register('firstName')}
          />
        </SimpleGrid>
      </Paper>
    </form>
  );
};

export default UpdateProfileForm;
